<template>
  <el-dialog
    title="提款退款"
    :visible.sync="dialogVisible"
    width="480px"
    :close-on-click-modal="false"
    append-to-body
    @closed="handleClosed"
  >
    <el-form label-width="80px" size="small">
      <el-form-item label="订单号">
        <span>{{ row && row.orderNo }}</span>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          v-model="msg"
          type="textarea"
          :rows="3"
          maxlength="200"
          show-word-limit
          placeholder="选填"
          clearable
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="primary" :loading="submitting" @click="submit">确定退款</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { computed, getCurrentInstance, ref, watch } from 'vue'
import { payoutRefund } from '@/api/finance/moneyManagement'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  row: {
    type: Object,
    default: null,
  },
})

const emit = defineEmits(['update:visible', 'success'])

const { proxy } = getCurrentInstance()
const submitting = ref(false)
const msg = ref('')

const dialogVisible = computed({
  get: () => props.visible,
  set: val => emit('update:visible', val),
})

watch(
  () => props.visible,
  val => {
    if (val) msg.value = ''
  }
)

function handleClosed() {
  msg.value = ''
  submitting.value = false
}

async function submit() {
  if (!props.row?.orderNo) return

  const payload = { order_id: props.row.orderNo }
  const text = (msg.value || '').trim()
  if (text) payload.msg = text

  submitting.value = true
  try {
    const res = await payoutRefund(payload)
    if (res.code === 0) {
      proxy.$message.success('退款成功')
      dialogVisible.value = false
      emit('success')
    } else {
      proxy.$message.error(res.msg || '退款失败')
    }
  } catch (e) {
    proxy.$message.error(e?.message || '退款失败')
  } finally {
    submitting.value = false
  }
}
</script>
